import styled from "@emotion/styled";
import { FC, useCallback, useEffect, useState } from "react";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { ImgCard } from "../../common/component/ImgCard";
import { TypeEntity } from "../../module/product/entity/type.entity";
import { getTypeList } from "../../module/product/service/type.service";

const breadArr = [
	{
		title: "产品相关"
	}
]

export const TypeList: FC = () => {
	const [list, setList] = useState<TypeEntity[]>([]);

	const init = useCallback(async () => {
		const { data } = await getTypeList();
		setList(data);
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	return (
		<Container>
			<ImageFill src={"https://splashtest.oss-cn-shanghai.aliyuncs.com/img1/products.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>产品</h1>
				</div>
				<Bread value={breadArr} />

				<div className='inner-description'>
					<h2>世界在发展。我们是驱动力！</h2>
					<br />
					<div style={{textIndent: '1rem'}}>无论是对粉尘、热、冷、腐蚀性化学品的耐受性，还是巨大的速度考验，Optibelt 产品都具备强大的优势。在任何要求低振动的场合，即便速度很快，Optibelt 皮带也能确保性能不受影响。

不管在什么情况下，只要能抵抗极大的牵引力或强大的摩擦力，Optibelt 皮带就能持续运行，要么强大而有力，要么细致而精准。</div>
				</div>
				<div className='card-list'>
					{list &&
						list.map((item) => {
							return <ImgCard key={item.id} className='item col-lg-3 col-md-6 col-xs-12' img={item.image??""} linkTitle={item.title??""} url={"/type/" + item.id} />;
						})}
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		margin: -7em auto 0;
		background: white;
		padding: 1em;
		z-index: 10;
		position: relative;

		.card-list {
			display: flex;
			flex-wrap: wrap;
			justify-content: left;
			margin: 2rem -1rem;

			.item {
				padding: 1rem;
			}
		}
	}
`;
